(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("speedyScreenCarriChat", {
            controller: speedyScreenCarriChat,
            bindings: {
                brandId: "<",
                userData: "<",
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/carri-chat/carri-chat.component.html'
        });

    speedyScreenCarriChat.$inject = ['$scope', 'speedyScreenCarriChatService'];

    function speedyScreenCarriChat($scope, speedyScreenCarriChatService) {

        var self = this;
        self.loading = true;
        self.conversations = [];

        var init = function () {
            self.userId = self.userData.candidate_id;
            self.getUserCarriChatConversations(self.brandId, self.userId);
        };

        self.getUserCarriChatConversations = function (brandId, userId) {
            speedyScreenCarriChatService.getUserCarriChatConversations(brandId, userId)
                .then(function (res) {
                    self.conversations = res;
                    if (self.conversations.length) {
                        groupConversationSameDay();
                        self.initFilter();
                    }
                }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                delete self.loading;
            });
        };

        self.applyFilter = function () {
            var startDate = moment(self.start_date_filter).valueOf();
            var endtDate = moment(self.end_date_filter).valueOf();

            for (var i = 0; i < self.conversations.length; i++) {
                var conversationDate = moment(self.conversations[i].created).valueOf();
                self.conversations[i].hideFiltered = !(conversationDate >= startDate && conversationDate <= endtDate);
            }
        };

        self.showResetButton = function () {
            return(!isSameDate(self.conversations[0].created,self.start_date_filter) || !isSameDate(self.conversations[self.conversations.length - 1].created,self.end_date_filter));
        };

        self.onRangeApplied = function (range, from, to) {
            self.from = from;
            self.to = to;
            self.start_date_filter = new Date(from);
            self.end_date_filter = new Date(to.endOf('day'));
            self.start_date_filter_display = new Date(from.endOf('day'));
            self.end_date_filter_display = new Date(to.endOf('day'));
            self.showDateRangePicker = false;
            self.applyFilter();
        };

        var groupConversationSameDay = function () {
            if (self.conversations.length > 1) {
                for (var i = 1; i < self.conversations.length; i++) {
                    if (
                        isSameDate(self.conversations[i].created,self.conversations[i - 1].created)
                    ) {
                        self.conversations[i].samePreviousDate = true;
                    }
                }
            }
        };

        var isSameDate = function (dateA, dateB) {
            return (moment(dateA).isSame(dateB, 'day')
            && moment(dateA).isSame(dateB, 'month')
            && moment(dateA).isSame(dateB, 'year'));
        };

        self.initFilter = function () {
            self.dateMin = new Date(self.conversations[0].created);
            var from =  moment(self.conversations[0].created);
            self.dateMax = new Date(self.conversations[self.conversations.length - 1].created);
            var to =  moment(self.conversations[self.conversations.length - 1].created);
            self.onRangeApplied(null, from, to);
        };

        self.$onInit = function () {
            init();
        };

        self.$onDestroy = function () {
        };
    }
})();
